import { render, staticRenderFns } from "./ArsipTicketComment.vue?vue&type=template&id=557c9b4e&scoped=true"
import script from "./ArsipTicketComment.vue?vue&type=script&lang=js"
export * from "./ArsipTicketComment.vue?vue&type=script&lang=js"
import style0 from "./ArsipTicketComment.vue?vue&type=style&index=0&id=557c9b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557c9b4e",
  null
  
)

export default component.exports